import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=4e37d7a6&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e37d7a6')) {
      api.createRecord('4e37d7a6', component.options)
    } else {
      api.reload('4e37d7a6', component.options)
    }
    module.hot.accept("./Theme.vue?vue&type=template&id=4e37d7a6&", function () {
      api.rerender('4e37d7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/Theme.vue"
export default component.exports